/**
 * Formats hour and minute as HH:MM (24-hour format)
 * Handles the special case where hour 24 represents midnight (24:00)
 */
export function formatTime24(hour: number, minute: number): string {
  // Special case: 24:00 represents midnight
  if (hour === 24 && minute === 0) {
    return "24:00";
  }
  return `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
}
